export default __webpack_public_path__ + "static/image-57-24cb72206245c060de0e403cdf68e7fd.jpg";